import { lazy } from 'react';

const USBusinessIdentifier = lazy(
  () => import('containers/preunderwriting/US/USBusinessIdentifier')
);

const USBusinessDetails = lazy(
  () => import('containers/preunderwriting/US/USBusinessDetails')
);

const USBusinessEligibility = lazy(
  () => import('containers/preunderwriting/US/USBusinessEligibility')
);

// const USEligibleGranted = lazy(
//   () => import('containers/preunderwriting/US/USEligibleGranted')
// );

const USEligibleDenied = lazy(
  () => import('containers/preunderwriting/US/USEligibleDenied')
);

const USApplicants = lazy(
  () => import('containers/preunderwriting/US/USApplicants')
);

const USAssistedCreateAccount = lazy(
  () => import('containers/preunderwriting/US/USCreateAccount')
);

const USAssistedRegisterCompany = lazy(
  () => import('containers/preunderwriting/US/USRegisterCompany')
);

const USCustomerLanding = lazy(
  () => import('containers/preunderwriting/US/USCustomerLanding')
);

const USCompanyDetails = lazy(
  () => import('containers/underwriting/US/USCompanyDetails')
);

const USPersonalDetails = lazy(
  () => import('containers/underwriting/US/USPersonalDetails')
);

const USBankDetails = lazy(
  () => import('containers/underwriting/US/USBankDetails')
);

const USFinancialDetails = lazy(
  () => import('containers/underwriting/US/USFinancialDetails')
);

const USReview = lazy(() => import('containers/underwriting/US/USReview'));

const USApplicationStatus = lazy(
  () => import('containers/underwriting/US/USApplicationStatus')
);

const USLegalApplication = lazy(
  () => import('containers/postunderwriting/US/USLegalApplication')
);

const USACHAuthorization = lazy(
  () => import('containers/postunderwriting/US/USACHAuthorization')
);

const USVirtualSiteVisit = lazy(
  () => import('containers/postunderwriting/US/USVirtualSiteVisit')
);

const USOfferGranted = lazy(
  () => import('containers/underwriting/US/USOfferGranted')
);

const USOfferAccepted = lazy(
  () => import('containers/underwriting/US/USOfferAccepted')
);

const USReferrals = lazy(
  () => import('containers/channelpartner/US/USReferrals')
);

const USLegalDocs = lazy(
  () => import('containers/postunderwriting/US/USLegalDocs')
);

const USLegalGenerated = lazy(
  () => import('containers/postunderwriting/US/USLegalGenerated')
);

const USLegalCompleted = lazy(
  () => import('containers/postunderwriting/US/USLegalCompleted')
);

const USLegalRejected = lazy(
  () => import('containers/postunderwriting/US/USLegalRejected')
);

const USApprovedStage = lazy(
  () => import('containers/postunderwriting/US/USApprovedStage')
);

const USIntroduction = lazy(
  () => import('containers/underwriting/US/USIntroduction')
);

const USSubmit = lazy(() => import('containers/channelpartner/US/USSubmit'));

const USPostLegalCompleted = lazy(
  () => import('containers/postunderwriting/US/USPostLegalCompleted')
);

const USLimitApproved = lazy(
  () => import('containers/postunderwriting/US/USLimitApproved')
);

// Revamped US underwriting flow (NDAJ revamp) — the multi-step onboarding form.
const USUnderwritingV2 = lazy(
  () => import('containers/underwriting/USV2/MultiStepForm')
);

// Landing page for the revamped US underwriting flow.
const USOnboardingIntro = lazy(
  () => import('containers/underwriting/USV2/Introduction')
);

const USTrackApplication = lazy(
  () => import('containers/underwriting/USV2/TrackApplication')
);

export const USRouteMap = {
  USBusinessIdentifier,
  USBusinessDetails,
  USBusinessEligibility,
  USEligibleDenied,
  USApplicants,
  USAssistedCreateAccount,
  USAssistedRegisterCompany,
  USCustomerLanding,
  USCompanyDetails,
  USPersonalDetails,
  USBankDetails,
  USFinancialDetails,
  USReview,
  USApplicationStatus,
  USLegalApplication,
  USACHAuthorization,
  USVirtualSiteVisit,
  USOfferGranted,
  USOfferAccepted,
  USReferrals,
  USSubmit,
  USLegalDocs,
  USLegalGenerated,
  USLegalCompleted,
  USPostLegalCompleted,
  USLegalRejected,
  USApprovedStage,
  USIntroduction,
  USLimitApproved,
  USUnderwritingV2,
  USOnboardingIntro,
  USTrackApplication,
};
